export const state = () => ({
	campaigns: [],
	campaign: {},
	isLoading: false,
	companiesAdmin: [],
	activities: [],
	socialNetwork: {
		twitter_account: {},
		insta_account: {},
	},
	claimsReward: [],
})

export const actions = {
	async getCampaignCompany({ commit, rootGetters }) {
		commit('setIsLoading', true)
		commit('setListCompanyCampaigns', [])

		return await useNuxtApp()
			.$api(`/api/campaigns/company/${rootGetters.companyId}/`)
			.then((res) => {
				commit('setListCompanyCampaigns', res)
				commit('setIsLoading', false)
				return res
			})
			.catch(() => {
				commit('setIsLoading', false)
				commit('setListCompanyCampaigns', [])
			})
	},

	async getOneCampaign({ commit }, { campaignId }) {
		commit('setIsLoading', true)
		commit('setOneCampaign', {})

		return await useNuxtApp()
			.$api(`/api/campaigns/${campaignId}/`)
			.then((res) => {
				commit('setOneCampaign', res)
				commit('setIsLoading', false)
				return res
			})
			.catch((err) => {
				commit('setIsLoading', false)
				throw err
			})
	},

	async getAllCompanyAdmin({ commit }) {
		return await useNuxtApp()
			.$api('/api/companies/')
			.then((res) => {
				res.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
				commit('setCompaniesAdmin', res)
				return res
			})
	},
}

export const mutations = {
	setOneCampaign(state, data) {
		state.campaign = data
	},

	setListCompanyCampaigns(state, data) {
		state.campaigns = []
		let i = 0
		const status = {
			WAI: 'En attente',
			STA: 'En cours',
			END: 'Terminé',
			DRA: 'Brouillon',
		}
		data.forEach((campaign) => {
			state.campaigns[i] = {
				tag: campaign.tag,
				campaign_type: campaign.campaign_type,
				description: campaign.description,
				picture_url: campaign.picture_url,
				status: status[campaign.status],
				status_api: campaign.status,
				end_date: campaign.end_date,
				start_date: campaign.start_date,
				total_actions: campaign.total_actions,
				total_rewards: campaign.total_rewards,
				targeting_ids: campaign.targeting_ids,
				id: campaign.id,
			}
			i++
		})
	},

	setIsLoading(state, data) {
		state.isLoading = data
	},

	setActivities(state, data) {
		state.activities = data
	},

	setSocialNetwork(state, data) {
		state.socialNetwork = data
	},

	setClaimsReward(state, data) {
		state.claimsReward = data
	},

	setCompaniesAdmin(state, data) {
		state.companiesAdmin = data
	},
}
